import { render, staticRenderFns } from "./paymentData.vue?vue&type=template&id=67cb556a&scoped=true&"
import script from "./paymentData.vue?vue&type=script&lang=js&"
export * from "./paymentData.vue?vue&type=script&lang=js&"
import style0 from "./paymentData.vue?vue&type=style&index=0&id=67cb556a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb556a",
  null
  
)

export default component.exports